import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';
import { toast } from '../../../components/ui/toast';
import { fetchWithAuth } from '../../../utils/fetchWithAuth';


const API = process.env.REACT_APP_API_BASE;

export default function ReplyBotOAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { token } = useAuth();
  

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get('code');
    const state = query.get('state');

    if (!code || !state) {
      toast({ title: 'Invalid redirect URL', variant: 'destructive' });
      return;
    }

    const finalizeConnection = async () => {
      try {
        console.log(token);
        const res = await fetchWithAuth(`${API}/api/replybot/oauth/finalize`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            type: state, // 'instagram' or 'whatsapp'
            code,
          }),
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Failed to connect');

        toast({ title: `${state.toUpperCase()} connected successfully ✅` });
        navigate('apps/replybot/onboarding');
      } catch (err) {
        toast({
          title: `Failed to connect ${state}`,
          description: err.message,
          variant: 'destructive',
        });
      }
    };

    finalizeConnection();
  }, [location, navigate, token]);

  return (
    <div className="h-screen w-full flex items-center justify-center">
      <Loader2 className="animate-spin h-6 w-6 mr-2" /> Connecting your account...
    </div>
  );
}
